export const usersReducer = (state = {loading: false, resultuser: null, users: [], user: null, total: 0} , action) => {
    switch (action.type) {
        case 'USER_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                users: action.payload.users,
                total: action.payload.total
            }
        case 'USER_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                user: action.payload.user
            }
        case 'USER_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultuser: action.payload.message,
                user: action.payload.user,
                users: [...state.users, action.payload.user],
            }
        case 'USER_EDIT_SUCCESS':
            if(action.payload.user){
                return {
                    ...state,
                    loading: false,
                    resultuser: action.payload.message,
                    user: action.payload.user,
                    users: state.users.map(user => user._id === action.payload.user._id ? action.payload.user : user),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultuser: action.payload
                }
            }
        case 'USER_ENABLEDISABLE_SUCCESS':
            return {
                ...state,
                loading:false,
                user: {...state.user, active: action.payload.stateuser},
                users: state.users.map(user => user._id === action.payload.idUser ? {...user, active: action.payload.stateuser} : user),
                resultuser: action.payload.message
            }
        case 'USER_RESET_RESULT':
            return {
                ...state,
                resultuser: null
            }
        case 'USER_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'USER_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

